import React from 'react';
import ImageComponent from 'atoms/Image';

const InlineErrorsComp = props => {
  const { show, errorMsg = '', cssClass = '', errImage } = props;
  return show ? (
    <div className={`inline-error-container ${cssClass}`}>
      <ImageComponent srcFile={errImage} />
      <div className='error-message'>{errorMsg}</div>
    </div>
  ) : null;
};
const InlineErrors = React.memo(InlineErrorsComp);
export default InlineErrors;
